import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/website-qr-eee.png")